module.exports = __webpack_public_path__ + "img/ibmp_nasal_passo_2.6a164945.gif";